// src/utils/postUtils.js

// Primo testo trovato
export function extractFirstText(obj) {
  let first = "";
  let second = "";

  for (const group of obj?.groups ?? []) {
    for (const block of group?.blocks ?? []) {
      if (block?.type === "T") {
        const txt = block?.content?.content;
        if (typeof txt === "string" && txt.trim() !== "") {
          if (!first) {
            first = txt;
          } else if (!second) {
            second = txt;
          }
        }
      }
    }
  }

  return first || "";
}

// Secondo testo trovato
export function extractSecondText(obj) {
  let first = "";
  let second = "";

  for (const group of obj?.groups ?? []) {
    for (const block of group?.blocks ?? []) {
      if (block?.type === "T") {
        const txt = block?.content?.content;
        if (typeof txt === "string" && txt.trim() !== "") {
          if (!first) {
            first = txt;
          } else if (!second) {
            second = txt;
          }
        }
      }
    }
  }

  return second || "";
}

// Prima immagine trovata (URL)
export function extractFirstImageUrl(obj) {
  for (const group of obj?.groups ?? []) {
    for (const block of group?.blocks ?? []) {
      if (block?.type === "I") {
        const src = block?.content?.src;
        if (typeof src === "string" && src.trim() !== "") {
          return src;
        }
      }
    }
  }
  return "";
}

export const CONTENT_APP_PATHS = {
  POST: "/post/:id",
  QUIZ_ATTEMPT: "quiz-attempt/:id",
  SHOWROOM: "/showrooms/:id",
  BUSINESS: "/business/:id",
};
